export const voucherContainer = theme => ({
  maxWidth: 550,
  paddingTop: 40,
  [theme.media.smallMobile]: {
    padding: 40
  },
  [theme.media.mobile]: {
    padding: 40
  }
})

export const voucherButtonGroup = theme => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '20px',
  [theme.media.smallMobile]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 0
  },
  [theme.media.mobile]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 0
  },
  [theme.media.tablet]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 0
  }
})

export const voucherButton = theme => ({
  width: 250,
  margin: [20, 0],
  [theme.media.mobile]: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
})

export const voucherValidationErrorStyles = theme => ({
  voucherContainer: voucherContainer(theme),

  iconFrame: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 14
  },

  title: {
    fontSize: 30,
    fontWeight: 500,
    lineHeight: '36px',
    textAlign: 'center',
    marginBottom: 26,
    [theme.media.smallMobile]: {
      fontSize: 26
    },
    [theme.media.mobile]: {
      fontSize: 26
    }
  },

  errorMessage: {
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 325,
    lineHeight: '28px',
    [theme.media.smallMobile]: {
      fontSize: 16
    },
    [theme.media.mobile]: {
      fontSize: 18
    }
  },

  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    [theme.media.desktop]: {
      width: 550
    }
  },

  buttons: voucherButtonGroup(theme),

  button: {
    ...voucherButton(theme),
    padding: [10, 0]
  }
})
